import { render, staticRenderFns } from "./ForgotPwdLayout.vue?vue&type=template&id=6ecda7b2&scoped=true"
import script from "./ForgotPwdLayout.vue?vue&type=script&lang=js"
export * from "./ForgotPwdLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecda7b2",
  null
  
)

export default component.exports